import React from 'react';
import { Grid } from '@material-ui/core';
import { CORP_BLUE, FONT_SIZE_UPLOAD } from 'config/config';
import { FileUpload } from '@mui/icons-material';
import { AddOutlined, DeleteForeverOutlined } from '@material-ui/icons';

const UploadComponent = props => {
  const { classes, titulo, changeSingleFile, deleteSingleFile, files, days, filesOtros, changeSingleFileOtros, deleteSingleFileOtros, reclamo, uploadType, isDerivacion } = props;

  const getView = () => {

    if (days && uploadType === 'recurso') {
      if (days > 0) {
        return hasView()
      } else {
        return <Grid container alignItems="center" key={'0A'}>
          <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
          <Grid item xs={12}>
            <p style={{ fontSize: FONT_SIZE_UPLOAD, marginTop: 10 }}>{'No es posible subir recurso posterior a 5 días hábiles a partir de la fecha de notificación.'}</p>
          </Grid>
        </Grid>
      }
    } else {
      return (
        hasView()
      )
    }
  }

  const otrosView = () => {

    return (
      <Grid container>
        <Grid container alignItems="center" key={'0A'}>

          <Grid item xs={10}>
            <p style={{ fontSize: FONT_SIZE_UPLOAD, fontWeight: 'bold' }}>{isDerivacion ? 'Adjuntar otros antecendentes (Máximo 2)' : 'Otros adjuntos (Máximo 2)'}</p>
          </Grid>
          <Grid item xs={2} container justifyContent="center">
            <Grid item xs={3}>
              <input
                accept=".pdf"
                className={classes.input}
                id={'contained-button-file-input-otros'}
                type="file"
                onChange={e => changeSingleFileOtros(e)}
                hidden
              />
              <label htmlFor={'contained-button-file-input-otros'}>
                <AddOutlined style={{ color: 'green', marginTop: 5, fontSize: 40, cursor: 'pointer' }} />
              </label>
            </Grid>
          </Grid>
        </Grid>


        {filesOtros.length === 0
          ? null
          : filesOtros.map((item, index) => {
            return (
              <Grid container key={index}>
                <Grid container>
                  <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
                </Grid>
                <Grid container>
                  <Grid item xs={10} container alignItems="center" style={{ fontSize: FONT_SIZE_UPLOAD }}>
                    {item.file.name}
                  </Grid>
                  <Grid item xs={2} container justifyContent="flex-end">
                    <DeleteForeverOutlined
                      onClick={e => deleteSingleFileOtros(index)}
                      style={{
                        color: 'red',
                        marginTop: 5,
                        marginBottom: 5,
                        fontSize: 40,
                        cursor: 'pointer'
                      }}
                    />
                  </Grid>
                </Grid>

              </Grid>
            );
          })}

        {reclamo.doc_descripcion !== '' ? (
          <Grid container>
            <Grid item xs={12} style={{ textAlign: 'left', paddingTop: 15, fontWeight: 'bold' }}>
              <p style={{ fontSize: FONT_SIZE_UPLOAD, fontWeight: 'bold' }}>Comentario:</p>
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'left', paddingTop: 5 }}>
              <p style={{ fontSize: FONT_SIZE_UPLOAD }}>{reclamo.doc_descripcion}</p>
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    )

  }

  const hasView = () => {
    return <Grid container alignItems="center" key={'0A'}>
      <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
      <Grid item xs={10}>
        <p style={{ fontSize: FONT_SIZE_UPLOAD }}>{titulo}</p>
      </Grid>
      <Grid item xs={2} container justifyContent="center">
        <Grid item xs={3}>
          <input
            accept=".pdf"
            className={classes.input}
            id={'contained-button-file-input'}
            type="file"
            onChange={e => changeSingleFile(e)}
            hidden
          />
          <label htmlFor={'contained-button-file-input'}>
            {isDerivacion ?
              <AddOutlined style={{ color: 'green', marginTop: 5, fontSize: 40, cursor: 'pointer' }} />
              :
              <FileUpload style={{ color: 'green', marginTop: 5, fontSize: 40, cursor: 'pointer' }} />
            }

          </label>
        </Grid>
      </Grid>
      {files.length === 0
        ? null
        : files.map((item, index) => {
          return (
            <Grid container key={index}>
              <Grid container>
                <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
              </Grid>
              <Grid container>
                <Grid item xs={10} container alignItems="center" style={{ fontSize: FONT_SIZE_UPLOAD }}>
                  {item.file.name}
                </Grid>
                <Grid item xs={2} container justifyContent="flex-end">
                  <DeleteForeverOutlined
                    onClick={e => deleteSingleFile(index)}
                    style={{
                      color: 'red',
                      marginTop: 5,
                      marginBottom: 5,
                      fontSize: 40,
                      cursor: 'pointer'
                    }}
                  />
                </Grid>
              </Grid>

            </Grid>
          );
        })}
      <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
      {otrosView()}
    </Grid>
  }

  return (
    <Grid container>

      {getView()}




    </Grid>
  );
};

export default UploadComponent;
